import axios from "axios";
import { getApiConfig } from "@/lib/api/config";

const { baseUrl } = getApiConfig();

export const axiosPublic = axios.create({
  baseURL: baseUrl || undefined,
  headers: {
    "Content-Type": "application/json",
    "ngrok-skip-browser-warning": "true",
  },
});
